function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgHiper = function SvgHiper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Hiper_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Hiper_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Hiper_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 29,
    height: 29
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.963h28.558V35H3V6.963z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Hiper_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.48 7.076c2.347-.543 4.71.936 5.252 3.288l3.714 16.115c.287 1.244.008 6.231-.666 7.212H7.248L3.112 16.058c-.542-2.351.935-4.719 3.282-5.262l16.086-3.72z",
    fill: "#F4811F"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.589 24.297h-1.326v-2.894H7.56v2.894H6.234v-6.684h1.325v2.61h2.704v-2.61h1.326v6.684z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.216 17.866c0 .11-.021.213-.066.31a.814.814 0 01-1.058.422.807.807 0 01-.421-.423.778.778 0 01-.062-.31.795.795 0 011.104-.736.805.805 0 01.437.424c.045.098.066.201.066.313z",
    fill: "#FFF100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.643 20.216c-.238 0-.439.048-.604.142a1.7 1.7 0 00-.463.416v2.214c.13.155.266.263.415.325.15.062.31.093.48.093a.935.935 0 00.8-.397c.096-.134.171-.304.223-.51.05-.208.078-.454.078-.739 0-.282-.022-.52-.065-.716a1.455 1.455 0 00-.187-.478.733.733 0 00-.291-.268.873.873 0 00-.386-.082zm-2.342 5.701v-1.545l-.067.001a2.65 2.65 0 01-1.175-.265c-.791-.408-1.19-1.243-1.275-2.418v-2.226h1.275c0 .623.038 1.687 0 2.518 0 .19.059.452.126.63.066.177.156.323.265.437.112.115.242.199.393.254.139.052.29.08.458.083v-3.922h.783c.081 0 .15.018.204.055.056.037.09.095.108.171l.107.438c.1-.111.206-.214.315-.307a1.917 1.917 0 01.777-.399c.149-.036.31-.055.484-.055.265 0 .507.058.728.172.221.114.413.28.573.495.452.61.508.953.508 1.726 0 .373-.05.718-.151 1.038-.1.318-.242.594-.427.828a1.988 1.988 0 01-.665.548c-.26.132-.55.199-.872.199-.27 0-.5-.041-.689-.124a1.807 1.807 0 01-.507-.335v2.003H15.3zM22.938 20.13c-.326 0-.58.094-.765.285-.183.189-.302.457-.356.802h2.11c0-.144-.019-.282-.058-.412a.957.957 0 00-.18-.347.893.893 0 00-.309-.24 1.037 1.037 0 00-.442-.088zm-.026-.747c.316 0 .606.05.87.153.264.102.491.251.682.443.191.193.34.268.448.55a2.702 2.702 0 01.145 1.204.433.433 0 01-.048.149.177.177 0 01-.089.077.398.398 0 01-.144.023h-2.983c.02.242.063.451.13.63.067.177.156.323.266.436.111.116.241.2.392.255.151.056.317.084.503.084.183 0 .343-.023.478-.069a2.59 2.59 0 00.358-.146c.102-.051.193-.1.273-.146a.487.487 0 01.237-.067c.094 0 .17.038.231.115l.367.473a2 2 0 01-.458.4c-.168.106-.34.19-.52.252s-.361.107-.544.134c-.186.026-.362.04-.534.04-2.284 0-2.938-2.633-1.81-4.264.172-.25.456-.4.75-.53.295-.13.628-.196 1-.196zM25.937 24.297v-4.833h.75c.13 0 .22.024.272.07.052.047.09.13.105.246l.065.508c.15-.285.326-.51.526-.673.2-.164.434-.248.698-.248.218 0 .398.052.538.157l-.096.793c-.007.06-.027.103-.06.127a.225.225 0 01-.135.038c-.05 0-.122-.007-.216-.022a1.598 1.598 0 00-.26-.023.923.923 0 00-.315.05.755.755 0 00-.247.15 1.04 1.04 0 00-.193.238 2.152 2.152 0 00-.156.322v3.1h-1.276z",
    fill: "#fff"
  })));
};
SvgHiper.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgHiper.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgHiper;